import { render, staticRenderFns } from "./TitleWithAction.vue?vue&type=template&id=05c2aa7d"
import script from "./TitleWithAction.vue?vue&type=script&lang=js"
export * from "./TitleWithAction.vue?vue&type=script&lang=js"
import style0 from "./TitleWithAction.vue?vue&type=style&index=0&id=05c2aa7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports